import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export interface OpsHubActiveAccount {
  bankCode: string;
  bankName: string;
  holderName?: string;
}

// integration_outbox health (карточка outbox-admin-visibility, волна 4):
// застрявшие/мёртвые исходящие AMO/LOS-вызовы. stuck = pending с attempts>=3.
export interface OpsHubIntegrations {
  pending: number;
  dead: number;
  stuck: number;
  oldestPendingMinutes: number | null;
}

// awaitingQr удалён 2026-06-12 вместе с Ozon/WB-метриками ops-hub stats
// (волна 2 PR5) — модуль Ozon/WB заархивирован (archive/ozonwb-flow).
export interface OpsHubStats {
  ordersOpen: number;
  readyForPickup: number;
  shiftTurnoverGel: number | null;
  shiftOperationCount: number | null;
  shiftOpenedAt: string | null;
  activeAccount: OpsHubActiveAccount | null;
  kbArticleCount: number;
  warehouseShelfCount: number;
  receptionLineCount: number;
  ordersNeedingAction: number;
  integrations: OpsHubIntegrations;
}

export interface UseOpsHubStatsResult {
  isLoading: boolean;
  isError: boolean;
  data: OpsHubStats | undefined;
}

export function useOpsHubStats(): UseOpsHubStatsResult {
  return useQuery({
    queryKey: ["ops-hub-stats"],
    queryFn: () => api<OpsHubStats>("/admin/ops-hub/stats"),
    staleTime: 30_000,
  });
}
